import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { AppBreadcrumbs } from "./Breadcrumbs";

const MainContainer = ({ children, open, isMobile, drawerWidth = 260 }) => {
    const location = useLocation();

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                ml: !isMobile && open ? 0 : `${-drawerWidth}px`,
                transition: theme =>
                    theme.transitions.create("margin-left", {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.standard
                    })
            }}
        >
            <AnimatePresence mode="wait">
                <motion.div
                    key={location.pathname}
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -12 }}
                    transition={{ duration: 0.25, ease: "easeOut" }}
                >
                    <AppBreadcrumbs />
                    {children}
                </motion.div>
            </AnimatePresence>
        </Box>
    );
};

export default MainContainer;
